import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }
        
    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.firmas.delete}
                postUrl={api.proyectos.config.firmas.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Firma ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Firma"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                onGotData={(data) => this.SetData(data)}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className={'mt-2'}>
                    <Col className="col-2">
                        <Label>Cargo</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="cargo" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                
                <Row className={'mt-2'}>
                    <Col className="col-12">
                        <img src={api.BASE_URL + this.state.fileurl} alt="" width="100%"></img>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Delete.js